import { render, staticRenderFns } from "./fxb.vue?vue&type=template&id=5d57659e&scoped=true&"
var script = {}
import style0 from "./fxb.vue?vue&type=style&index=0&id=5d57659e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57659e",
  null
  
)

export default component.exports